import { render, staticRenderFns } from "./a-m-header-items.vue?vue&type=template&id=5d1f7d1b&"
import script from "./a-m-header-items.vue?vue&type=script&lang=js&"
export * from "./a-m-header-items.vue?vue&type=script&lang=js&"
import style0 from "./a-m-header-items.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports